<template>
  <BaseModal
    :heading="$t('global.actions.delete_category')"
    small
    parentRoute="products-categories"
  >
    <Flex direction="column">
      <BaseText>{{ $t('products.delete_title') }}</BaseText>

      <BaseRadio
        v-model="selectedValue"
        :options="options"
        v-test="'delete-category-options'"
      />
      <Flex
        direction="column"
        v-if="allSelected"
      >
        <BaseAlert
          v-if="allSelected"
          color="warning"
          :text="
            $t('products.category_warning', { amount: $route.query.products })
          "
        />
        <BaseCheckbox
          v-model="accepted"
          :label="$t('products.aware_category')"
          v-test="'acceptDelete'"
        />
      </Flex>
    </Flex>
    <template #footer>
      <BaseButton
        :disabled="allSelected && !accepted"
        :loading="isLoading"
        @click="onDelete"
        v-test="'deleteCategoryOnDelete'"
      >
        {{ $t('global.actions.delete') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import { flash } from '@/helpers/ui';

export default defineComponent({
  data() {
    return {
      accepted: false,
      isLoading: false,
      selectedValue: 'category',
      options: [
        {
          label: this.$t('products.only_category'),
          value: 'category',
        },
        {
          label: this.$t('products.category_and'),
          value: 'category_and',
        },
      ],
    };
  },
  computed: {
    allSelected() {
      return this.selectedValue === 'category_and';
    },
    categoryId() {
      return Number.parseInt(this.$route.params.id);
    },
  },
  methods: {
    onDelete() {
      this.isLoading = true;
      const id = this.categoryId;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation deleteProductCategory(
              $input: DeleteProductCategoryInput!
            ) {
              deleteProductCategory(input: $input) {
                productCategory {
                  id
                }
              }
            }
          `,
          variables: {
            input: {
              id: this.categoryId,
              deleteProducts: this.allSelected,
            },
          },
          update(cache) {
            const cacheId = `ProductCategory:${id}`;
            cache.evict({ id: cacheId, broadcast: false });
            cache.gc();
          },
        })
        .then(() => {
          this.$router.push({ name: 'products-categories' });
          flash(this.$t('global.flash.category_deleted'));
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
});
</script>
